// extracted by mini-css-extract-plugin
export default {"container":"Root_container__rzIej","header":"Root_header__FC1mm"};